import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { IMAGE_SRC } from '../../../shared-constants';

@Component({
  selector: 'app-table-action-cell',
  imports: [IonIcon, NgClass],
  templateUrl: './table-action-cell.component.html',
  styleUrls: ['./table-action-cell.component.scss'],
})
export class TableActionCellComponent {
  @Input() data!: unknown;
  @Input() hasEditButton = true;
  @Input() editButtonDisabled = false;
  @Input() hasDeleteButton = true;
  @Input() deleteButtonDisabled = true;

  @Output() emitEditButton = new EventEmitter();
  @Output() emitDeleteButton = new EventEmitter();

  readonly IMAGE = IMAGE_SRC;

  clickEdit(data: unknown) {
    this.emitEditButton.emit(data);
  }

  clickDelete(data: unknown) {
    this.emitDeleteButton.emit(data);
  }
}
